import Dialog from "../../General/ConfirmableDialog";
import {
  FC } from "react";
import {
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./ShopDetailsPopup.css";
import { IShopDetailsPopupProps } from "../../../interfaces/Fleet/IShopDetailsPopupProps";

const ShopDetailsPopup: FC<IShopDetailsPopupProps> = ({
  open,
  onClose,
  details,
}) => {
  if (!details) return null;

  const createGoogleMapsLink = (address: string) => {
    const encodedAddress = encodeURIComponent(address);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  };

  const detailItems = [
    {
      label: "Street Address",
      value: (
        <a
          href={createGoogleMapsLink(details.streetAddress)}
          target="_blank"
          rel="noopener noreferrer"
          className="address-link"
        >
          {details.streetAddress}
        </a>
      ),
    },
    { label: "Phone Number", value: details.phoneNumber },
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box className="shop-details-header">
          <Typography variant="h6">{details.shopName} Details</Typography>
          <IconButton onClick={onClose} className="close-icon">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <List className="centered-text">
          {detailItems.map((item, index) => (
            <ListItem key={index} className="centered-item">
              <ListItemText
                primary={
                  <Typography variant="subtitle1" className="primary-text">
                    {item.label}
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" className="secondary-text">
                    {item.value}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
        <Box className="button-container">
          <Button onClick={onClose} variant="contained" color="primary">
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShopDetailsPopup;
